import { cn } from '@/utils/tailwind';

export const TruncatedText = ({
  className,
  text,
  maxLength = 50,
}: {
  className?: string;
  text: string;
  maxLength?: number;
}) => {
  if (text.length <= maxLength)
    return <span className={cn('font-semibold', className)}>{text}</span>;
  return (
    <span title={text} className={cn('font-semibold', className)}>
      {text.slice(0, maxLength)}...
    </span>
  );
};
